function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Accept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,23.164C375.194,23.164 476.836,124.806 476.836,250C476.836,375.194 375.194,476.836 250,476.836C124.806,476.836 23.164,375.194 23.164,250C23.164,124.806 124.806,23.164 250,23.164ZM177.544,360.723C177.648,360.832 177.753,360.939 177.859,361.045C186.64,369.826 200.898,369.826 209.679,361.045L405.33,165.394C414.111,156.613 414.111,142.355 405.33,133.574C396.549,124.793 382.291,124.793 373.51,133.574L193.769,313.315L127.126,246.673C118.345,237.892 104.087,237.892 95.306,246.673C86.526,255.454 86.526,269.712 95.306,278.493L177.222,360.409C177.329,360.515 177.436,360.62 177.544,360.723Z",
    style: {
      fill: "rgb(38,173,136)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.d31a511d2d45a0fe04d50e3b4876e447.svg";
export { ForwardRef as ReactComponent };